import styled from 'styled-components';

export const Container = styled.div`
  box-shadow: 0px 1px 4px 0px #00000040;
  border-radius: 8px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Image = styled.img`
  width: 32px;
  height: 24px;
  border-radius: 4px;
  object-fit: cover;
  &.defaultImage {
    border: none;
  }
`;

export const Left = styled.div`
  display: flex;
  align-items: center;
`;

export const Right = styled.div`
  display: flex;
  align-items: center;
`;

export const Text = styled.div`
  font-size: 14px;
  color: #1a1b1c;
`;

export const UserImage = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 12px;
  object-fit: cover;
`;
